import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A violin and a flute are not in tune. To tune the violin and the flute, increase the tension of the string to put the violin in tune with the flute. When it is seems correct, press “next”.",
  theory: theory,
  layout: {
    type: "custom012800",
    options: {
      fluteImg: `${config.ASSETS_URL}/01/28/principle/flute.svg`,
      violinImg: `${config.ASSETS_URL}/01/28/principle/violin.svg`,
      violinParameter: {
        variable: "tension",
        from: 60,
        to: 100,
        step: 1,
        defaultValue: 80,
      },
      violinFormula: "sin(2*pi*sqrt(tension)/0.02074454145070457*t)",
      fluteFormula: "sin(2*pi*440*t)",
      fluteTemperature: 20,
    },
  },
};

export default principle;
